import { studioPathToJsonPath, resolveEditInfo, studioPath, jsonPathToStudioPath } from "@sanity/client/csm";
import { encodeSanityNodeData } from "@sanity/visual-editing-csm";
const encodeDataAttribute = (result, sourceMap, studioUrl, studioPathLike) => {
  if (!sourceMap || !studioUrl)
    return;
  const resultPath = studioPathToJsonPath(studioPathLike), editInfo = resolveEditInfo({
    resultPath,
    resultSourceMap: sourceMap,
    studioUrl
  });
  if (editInfo)
    return encodeSanityNodeData({
      baseUrl: editInfo.baseUrl,
      workspace: editInfo.workspace,
      tool: editInfo.tool,
      type: editInfo.type,
      id: editInfo.id,
      path: typeof editInfo.path == "string" ? editInfo.path : studioPath.toString(jsonPathToStudioPath(editInfo.path))
    });
};
function defineEncodeDataAttribute(result, sourceMap, studioUrl, basePath) {
  const parse = (path) => path ? typeof path == "string" ? studioPath.fromString(path) : path : [], parsedBasePath = parse(basePath);
  return Object.assign(
    (path) => encodeDataAttribute(result, sourceMap, studioUrl, [...parsedBasePath, ...parse(path)]),
    // The scope method creates a scoped version of encodeDataAttribute
    {
      scope: (scope) => defineEncodeDataAttribute(result, sourceMap, studioUrl, [
        ...parsedBasePath,
        ...parse(scope)
      ])
    }
  );
}
export {
  defineEncodeDataAttribute,
  encodeDataAttribute
};
//# sourceMappingURL=encode-data-attribute.js.map
